const validateCart = () => {

  const totalPriceElement = document.getElementById("subtotal");
  const totalPriceParent = parseInt(totalPriceElement.getAttribute("data-cart__total_without_format"));
  if (totalPriceParent != null) {
    const totalPrice = totalPriceParent;
    const limitCart = parseInt(document.querySelector('[name="cart_min_amount"]').value);
    const notifyParent = document.querySelector("#cart-limit");

    if (totalPrice >= limitCart) {
      if (!notifyParent.classList.contains("hidde")) {
        notifyParent.classList.add("hidde");
      }
      document.querySelector("#checkout").disabled = false;
    } else {
      notifyParent.classList.remove("hidde");
      document.querySelector("#checkout").disabled = true;
    }
  }
}

const checkMinAmount = () => {
  const totalCartParent = document.querySelector(".cart__blocks");
  const config = { attributes: true, childList: true, subtree: true };

  const observeParent = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.addedNodes.length > 0) {
        validateCart();
      }
    }
  }

  const observer = new MutationObserver(observeParent);
  observer.observe(totalCartParent, config);
  validateCart();
}


checkMinAmount();